//#region Styles
import {
    ContainerParts, 
    Part, Row,
    TitleSection, ResumeSection 
} from "components/styles";
//#endregion
//#region Components
import ResumeEventStep1 from "./components/ResumeEventStep1/ResumeEventStep1";
import ModifyFile from "./components/ModifyFile/ModifyFile";
import { useEffect } from "react";
//#endregion

const Step2 = ({
    form,
    errors,
    errorStack,
    setCanShowDialogLeavingPage 
}) => {
    useEffect(() => {
        setCanShowDialogLeavingPage(true);
    });
    const changeFieldFileData = value => {
        form.change("fileData", value, false);
    }
    return (
        <ContainerParts>
            <Part gap="20px">
                <Row>
                    <TitleSection>Resumen del evento:</TitleSection>
                </Row>
                <ResumeSection>
                    <ResumeEventStep1 
                        form={form.value}
                        errorStack={errorStack}/>
                    {(errorStack.stack.length > 0 || errorStack.rowCountFile === 0) && 
                        <ModifyFile
                            file={form.value.fileData}
                            changeForm={changeFieldFileData}
                            errors={errors}/>}
                </ResumeSection>
            </Part>
        </ContainerParts>
    );
}

export default Step2;